// Animates the CHRISTMAS Star Art's "Christ/Mas Love" centrepiece.
// The CHRISTMAS art is now DB-backed (star_arts table, rendered via Action Text).
// Action Text's sanitizer strips `id` attributes but keeps `class`, so the seed
// container is `<div class="christ-mas-love">` — we bind to that class. The old
// `#textContainer` id is kept as a fallback for any legacy static page.
const textContainer = document.querySelector('.christ-mas-love, #textContainer'); // element the text animates in.
const texts = ['Merry CHRISTMAS Love', 'Merry Christmas My Merry Mates', 'Merry Christmas Love', 'Christ Mas Love', 'Christ Was Love', 'the Christ HeartLight is Love'];
// Start at 0: the old value (400) is out of range, so texts[400] rendered
// "undefined" on the first cycle before wrapping into the real phrases.
let currentIndex = 0;

// Function to change text
function changeText() {
  // Fade out current text

  if (textContainer) {
    textContainer.classList.add('fade-out');

    textContainer.addEventListener('animationend', function() {
      // Update the text when fading out completes
      textContainer.textContent = texts[currentIndex];
      textContainer.classList.remove('fade-out'); // Clean up

      // Immediately start fading in the new text
      textContainer.classList.add('fade-in');

      // Listen for fade in to complete before starting next cycle
      textContainer.addEventListener('animationend', function() {
        textContainer.classList.remove('fade-in'); // Clean up

        // Prepare next text change
        currentIndex = (currentIndex + 1) % texts.length; // Update index for next text
        setTimeout(changeText, 1000); // Short delay before starting next fade out
      }, { once: true, capture: false });
    }, { once: true, capture: false });
  }
}

// Start the text change cycle
setTimeout(changeText, 500); // Initial start after a short delay
